import React from 'react';
import { default as BaseModal } from 'react-bootstrap/lib/Modal';

class SaveDialog extends React.PureComponent {
  constructor(...args) {
    super(...args);
    this.handleInput = this.handleInput.bind(this);

    this.state = {
      value: ''
    };
  }

  handleInput(e) {
    this.setState({ value: e.target.value });
  }

  onKeyPressHandler(event) {
    if (event.keyCode === 13) {
      event.preventDefault();
      this.props.saveProject(true, this.state.value);
    }
  }

  render() {
    const { show, close } = this.props;
    return (
      <BaseModal show={show} onHide={close}>
        <BaseModal.Header closeButton>
          <BaseModal.Title> Сохранить проект, как </BaseModal.Title>
        </BaseModal.Header>
        <BaseModal.Body>
          <form>
            <label>Название проекта</label>
            <input
              type="text"
              className="form-control"
              id="title"
              placeholder="Project Title"
              onChange={this.handleInput}
              autoFocus
              onKeyPress={this.onKeyPressHandler}
            />
            <div style={{ marginTop: '10px' }}>
              <button
                type="submit"
                className="btn btn-success btn-block"
                disabled={!this.state.value}
                onClick={e => {
                  e.preventDefault();
                  this.props.saveProject(true, this.state.value);
                }}
              >
                Сохранить
              </button>
            </div>
          </form>
        </BaseModal.Body>
      </BaseModal>
    );
  }
}
export default SaveDialog;
